import React from 'react';
import { Container } from 'components/UI/Container/Container';
import { Grid, GridRow, GridCol } from 'components/UI/Grid';
import { PrismicHTML, PrismicFluidImage } from 'components/Prismic';
import { PrismicLink } from 'components/PrismicLink';
import FeatureCTA from './FeatureCTA';
import { PositionsStyles, Positions, FeatureProps } from './types';

export const positionsMapping: { [index: string]: PositionsStyles } = {
    [Positions.Left]: {
        flexDirection: 'u-flex-row',
        leftColSize: '4',
        leftColOffset: '0',
        rightColSize: '7',
        rightColOffset: '1',
        r_tabletColSize: '6',
    },
    [Positions.Right]: {
        flexDirection: 'u-flex-rowReverse',
        leftColSize: '4',
        leftColOffset: '1',
        rightColSize: '7',
        rightColOffset: '0',
        r_tabletColSize: '6',
    },
    [Positions.Center]: {
        flexDirection: 'u-text-center',
        leftColSize: '6',
        leftColOffset: '3',
        rightColSize: '12',
        rightColOffset: '0',
        r_tabletColSize: '12',
    },
};

const setPositionsForItems = (position: Positions): PositionsStyles =>
    positionsMapping[position] || {
        flexDirection: '',
        leftColSize: '',
        rightColSize: '',
        leftColOffset: '',
        rightColOffset: '',
        tabletColSize: '',
    };

const Feature = ({
    slice: {
        primary: {
            feature_title: title,
            feature_position: position,
            feature_description: description,
            feature_cta_label: ctaLabel,
            feature_cta_link: ctaLink,
            feature_image: image,
            feature_imageSharp: imageSharp,
            feature_image_cta_link: ctaImageLink,
        },
    },
    sliceContext,
}: FeatureProps) => {
    return (
        <Container className="Feature-container" size="md">
            <Grid>
                <GridRow
                    horizontalAlign={'h-start'}
                    verticalAlign={'v-center'}
                    className={`Feature-row ${setPositionsForItems(position).flexDirection}`}
                >
                    <GridCol
                        colSize={setPositionsForItems(position).leftColSize}
                        offsetSize={setPositionsForItems(position).leftColOffset}
                        mobileColSize={'12'}
                        tabletColSize={setPositionsForItems(position).r_tabletColSize}
                        tabletOffsetSize={'0'}
                        mobileOffsetSize={'0'}
                        className={`Feature-txt`}
                    >
                        <PrismicHTML content={title} className="Feature-title" />
                        <PrismicHTML content={description} className="Feature-description" />
                        <FeatureCTA ctaLabel={ctaLabel} ctaLink={ctaLink} sliceContext={sliceContext} />
                    </GridCol>
                    <GridCol
                        colSize={setPositionsForItems(position).rightColSize}
                        offsetSize={setPositionsForItems(position).rightColOffset}
                        mobileColSize={'12'}
                        tabletColSize={setPositionsForItems(position).r_tabletColSize}
                        tabletOffsetSize={'0'}
                        mobileOffsetSize={'0'}
                        className={`Feature-image`}
                    >
                        {ctaImageLink ? (
                            <PrismicLink link={ctaImageLink} className="Feature-image-cta-link">
                                <PrismicFluidImage image={imageSharp} fallback={image} />
                            </PrismicLink>
                        ) : (
                            <PrismicFluidImage image={imageSharp} fallback={image} />
                        )}
                    </GridCol>
                </GridRow>
            </Grid>
        </Container>
    );
};

export { Feature };
